import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, watch} from 'vue';
import {changePassword as changePasswordApi} from '@/api/module/misc';
import {useRouter} from 'vue-router';
import {doAlert} from '@/util';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props, { expose: __expose }) {

const router = useRouter();

const formValid = ref(false);
const loading = ref(false);
const currentPassword = ref('');
const newPassword = ref('');
const newPasswordRepeat = ref('');

const form = ref<HTMLFormElement & VNodeRef | undefined>();

watch(() => [newPassword.value, newPasswordRepeat.value], () => form.value?.validate());


async function changePassword() {
  try {
    loading.value = true;
    if (!form.value?.validate()) return;
    await changePasswordApi(currentPassword.value, newPassword.value);
    await doAlert('Passwort erfolgreich geändert');
    router.push({name: 'dashboard'}).catch(console.error);
  } catch (err) {
    let message = (err as Error).message;
    if (message === 'current password wrong') message = 'Das aktuelle Passwort ist nicht korrekt.';
    await doAlert(message);
  } finally {
    loading.value = false;
  }
}

function rulePasswordRepeat(value: string) {
  return value === newPassword.value || 'Passwörter stimmen nicht überein';
}

function rulePassword(value: string | null | undefined) {
  if (!value) return 'erforderlich';
  if (value.length < 6) return 'mindestens sechs Zeichen';
  if (value.match(/^\d+$/)) return 'nicht nur Zahlen';
  if (value.match(/^[a-z]+$/)) return 'nicht nur Kleinbuchstaben';
  if (value.match(/^[A-Z]+$/)) return 'nicht nur Großbuchstaben';
  if (value.match(/^[A-Z][a-z]+$/)) return 'nicht nur ein Wort';

  return true;
}

function ruleRequired(value: string | null | undefined) {
  return Boolean(value) || 'erforderlich';
}

__expose({
  formValid,
  loading,
  currentPassword,
  newPassword,
  changePassword,
  rulePasswordRepeat,
  rulePassword,
  ruleRequired,
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        ref_key: "form",
        ref: form,
        modelValue: formValid.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValid).value = $event)),
        onSubmit: _withModifiers(changePassword, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            label: "Aktuelles Passwort",
            type: "password",
            modelValue: currentPassword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
            rules: [ruleRequired]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_text_field, {
            label: "Neues Passwort",
            type: "password",
            modelValue: newPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
            rules: [rulePassword]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_text_field, {
            label: "Passwort wiederholen",
            type: "password",
            modelValue: newPasswordRepeat.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPasswordRepeat).value = $event)),
            rules: [rulePasswordRepeat]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_btn, {
            type: "submit",
            block: "",
            color: "primary",
            loading: loading.value,
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("Passwort ändern")
            ], undefined, true),
            _: 1
          }, 8, ["loading", "disabled"])
        ], undefined, true),
        _: 1
      }, 8, ["modelValue"])
    ], undefined, true),
    _: 1
  }))
}
}

})